import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import { Container, Row, Col } from "react-bootstrap";


import styles from './offerPrecision.module.scss';

const OfferPrecision = (props) => {
    return (
        <section className={`${styles.OfferPrecision} OfferPrecision dd bg-white`}
            style={{
                backgroundColor:
                    props?.widgetData?.slug == "corporate-wellness-v3" ? props?.widgetData?.data?.[0]?.card_1_color : null,

            }}
        >
            <Container>
                <Row className='justify-content-center'>
                    <Col lg={12} className='h-100'>
                        <Row>
                            <h1 className={styles.head_offer}>{props?.widgetData?.heading}</h1>
                            <Col lg={6} className={styles.offer_left_col}>
                                <img src={props?.widgetData?.data?.[0]?.image} width={1022.528} height={599} className='img-fluid' />
                            </Col>
                            <Col lg={6} className={` ${styles.offer_right_col}`}>
                                <Accordion defaultActiveKey="0" className='accordianOfferPrecision'>
                                    {props?.widgetData?.data?.slice(1)?.map((item, index) => {
                                        return (<>
                                            <Accordion.Item eventKey={`${item}_${index}`}>
                                                <Accordion.Header className='headingAccordian'><span><img src={item?.image} width={48} height={48} className='img-fluid'></img></span><span className='textAccordian'>{item?.heading}</span></Accordion.Header>
                                                <Accordion.Body className='bodyAccordian'>
                                                    <p>{item?.description}</p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </>)
                                    })}
                                </Accordion>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default OfferPrecision;
